function isDefined(value) {
  return !(value === null || value === void 0);
}
export {
  isDefined
};
//# sourceMappingURL=lang-utils.js.map
